<template>
  <el-drawer
    :visible.sync='discoverVisible'
    direction="btt"
    class="disco-drawer"
    :size="isMobile ? '100%' : 'calc(100% - 65px)'"
    :before-close='closeDisco'
    close-on-press-escape
  >
    <span slot="title"><b>Discover</b></span>
    <div class="disco-search">
      <el-input ref="discoSearch" placeholder="Search for a workout" prefix-icon="el-icon-discover" v-model="discoSearch" clearable/>
    </div>

    <div>
      <label>{{discoSearch !== '' ? 'search results' : 'most recent'}}</label>
      <div class="wo-results">
        <div
          class="wo-result"
          v-for="(workout, i) in discoverResults"
          :key="i"
        >
          <el-card :body-style="{ padding: '0px' }">
            <div class="wo-result--bg-img" :style="'background-image: url(' + workout.image + ');'"></div>
            <div class="wo-content">
              <div class="wo-info">
                <div class="wo-info--name">{{ workout.name }}</div>
                <hr>
                <div>
                  <label>host</label><span>{{ workout.host }}</span>
                </div>
                <div>
                  <label>date</label><span>{{ st(i).getMonth() + '/' + st(i).getDate() + '/' + st(i).getFullYear() }}</span>
                </div>
                <div>
                  <label>time</label><span>{{ st(i).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) }}</span>
                </div>
              </div>
              <el-button class="reg-btn" type="default" size="mini" :icon="!isMobile ? '' : 'el-icon-plus'">{{!isMobile ? 'Register' : ''}}</el-button>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    
  </el-drawer>  
</template>

<script>
import firebase from 'firebase'

export default {
  props: {
    discoverVisible: Boolean
  },
  data() {
    return {
      discoSearch: '',
      discoverResults: [],
      st: (i) => new Date(this.discoverResults[i].startTime),
      isMobile: ''
    }
  },
  methods: {
    closeDisco(done) {
      this.$emit('hideDiscoDrawer')
      done()
    },
    getRecentWO() {
      let recent = []

      firebase.database().ref().child('scheduledWO').limitToLast(5).on('child_added', async snapshot => {
        await recent.push(snapshot.val())
      })
      recent.reverse()
      
      this.discoverResults = recent
    }
  },
  mounted() {
    this.getRecentWO()
  },
  created() {
    // ****** isMobile
    // Define our viewportWidth variable
    let viewportWidth
    // Set/update the viewportWidth value
    let setViewportWidth = () => {
      viewportWidth = window.innerWidth || document.documentElement.clientWidth
    }
    // Log the viewport width into the console
    let logWidth = () => {
      if (viewportWidth > 991) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    }
    // Set our initial width and log it
    setViewportWidth()
    logWidth()
    // On resize events, recalculate and log
    window.addEventListener('resize', () => {
      setViewportWidth()
      logWidth()
    }, false)
  },
  beforeUpdate() {
    this.getRecentWO()
    if (this.discoverVisible && !this.isMobile) {
      this.$nextTick(() => this.$refs.discoSearch.$el.querySelector('input').focus())
    }
  }
}
</script>

<style>
.disco-search {
  margin-top: 16px;
}

.disco-search input {
  border: 0;
  border-bottom: 1px solid #797c82;
  border-radius: 0;
  font-size: 20px;
  padding-left: 32px !important;
}

.wo-results {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 8px;
  margin-left: -8px;
  margin-top: 8px;
  width: calc(100% + 16px);
}

.wo-results .wo-result {
  margin: 0 8px 16px;
  width: calc(20% - 16px);
}

.wo-results .wo-result .wo-result--bg-img {
  width: 35%;
  background-position: center;
  background-size: cover;
}

.wo-results .wo-result .el-card .el-card__body {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.wo-results .wo-result .el-card {
  height: 100%;
}

.wo-results .wo-result .wo-content {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  letter-spacing: 0.25px;
  padding: 16px;
  width: 65%;
}

.wo-results .wo-result .wo-content .wo-info {
  padding-bottom: 16px;
}

.wo-results .wo-result .wo-content .wo-info hr {
  margin: 8px 0;
}

.wo-results .wo-result .wo-content .wo-info .wo-info--name {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: .5px;
}

.wo-results .wo-result .wo-content .wo-info label {
  display: inline-block;
  margin-right: 4px;
}

.wo-results .wo-result .wo-content .reg-btn {
  margin-top: auto;
}

/******************************
*
*
* MOBILE STYLES
*
*
******************************/

@media (max-width: 991px) {
  .wo-results {
    flex-direction: column;
  }

  .wo-results .wo-result {
    width: calc(100% - 16px);
  }

  .wo-results .wo-result .wo-content {
    flex-direction: row;
  }

  .wo-results .wo-result .wo-content .wo-info {
    padding: 0 16px 0 0;
  }

  .wo-results .wo-result .wo-content .reg-btn {
    height: 100%;
    margin-left: auto;
  }
}
</style>